import { api } from '@/core/api/';
import qs from 'querystring';

const URL = 'api/provider/specialist';

export const getSpecialistBySsnOrHdn = (ssnOrHdn, companyId) =>
  api.get(`${URL}/search/${ssnOrHdn}`, {
    params: { companyId },
  });

export const isSsnValid = async (ssnOrHdn) => {
  return await api.post(`${URL}/validateSsn/${ssnOrHdn}`);
};

export const getDetailInfo = (specialistId, companyId, academicYearId) =>
  api.get(`${URL}/detail/${specialistId}`, {
    params: {
      companyId,
      academicYearId,
    },
  });

export const getRequestInfo = () => api.get(`${URL}/requestinfo`);

export const getInitFilters = () => api.get(`${URL}/initfilters`);

export const getSpecialistsByProvider = (academicYearId, companyId, isActive) =>
  api.get(
    `${URL}/specialistsbyprovider/${academicYearId}/${companyId}/${isActive}`
  );

export const getSpecialistsBySpecialtyType = (
  specialtyTypeId,
  specialistId,
  companyId,
  academicYearId
) =>
  api.get(
    `${URL}/specialistsbyspecialtytype/${specialtyTypeId}/${specialistId}/${companyId}/${academicYearId}`
  );

export const getDisciplinesByServiceType = (serviceTypeId) =>
  api.get(`${URL}/disciplinesbyservicetype/${serviceTypeId}`);

export const search = (payload) =>
  api.get(`${URL}/search`, {
    params: {
      ...payload,
    },
  });

export const saveOrUpdateSpecialistLicense = (payload) =>
  api.post(`${URL}/saveorupdatespecialistlicense`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const isLicenseRelatedToLocationDiscipline = (specialistLicenseId) =>
  api.get(`${URL}/islicenserelatedtolocationdiscipline/${specialistLicenseId}`);

export const deleteSpecialistLicense = (specialistLicenseId) =>
  api.delete(`${URL}/deletespecialistlicense/${specialistLicenseId}`);

export const deleteSpecialistLicenseDocument = (specialistLicenseDocumentId) =>
  api.delete(
    `${URL}/deletespecialistlicensedocument/${specialistLicenseDocumentId}`
  );
export const getSpecialistLicenseDisciplines = (specialistId) =>
  api.get(`${URL}/specialistLicenseDisciplines/${specialistId}`);

export const getAllDisciplinesBySpecialtyType = (specialtyTypes) =>
  api.get(
    `${URL}/allDisciplinesBySpecialtyType?specialtyTypes=${specialtyTypes.join(
      '&specialtyTypes='
    )}`
  );

export const saveOrUpdateSpecialist = (payload) =>
  api.post(`${URL}/saveorupdatespecialist`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const insertNewSpecialistLocation = (payload) =>
  api.post(`${URL}/addServiceLocation`, payload);

export const getSpecialistLicenseDocuments = (specialistLicenseId) =>
  api.get(`${URL}/specialistlicensedocuments/${specialistLicenseId}`);

export const updateSpecialistLocation = (payload) =>
  api.put(`${URL}/editservicelocation`, payload);

export const deleteSpecialistLocation = (specialistLocationId) =>
  api.delete(`${URL}/deleteservicelocation/${specialistLocationId}`);
export const getValidationsToInactivate = (payload) =>
  api.get(`${URL}/validationsToInactivate`, {
    params: {
      ...payload,
    },
  });

export const inactivateSpecialist = ({
  specialistId,
  companyId,
  fiscalYearId,
}) =>
  api.put(
    `${URL}/inactivatespecialist/${specialistId}/${companyId}/${fiscalYearId}`
  );

export const isSAEESpecialist = ({ specialistId, fiscalYearId }) =>
  api.get(`${URL}/isSAEESpecialist/${specialistId}/${fiscalYearId}`);

export const activateSpecialist = ({ specialistId, companyId, fiscalYearId }) =>
  api.put(
    `${URL}/activespecialist/${specialistId}/${companyId}/${fiscalYearId}`
  );

export const searchSpecialistsForSupervise = (params) =>
  api.get(`${URL}/searchspecialistsforsupervise`, {
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
  });

export const searchSupervisedSpecialists = (params) =>
  api.get(`${URL}/searchsupervisedspecialists`, {
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
  });

export const updateSpecialistInfo = (payload) =>
  api.put(`${URL}/updatespecialistinfo`, payload);

export const saveSupervisedSpecialists = (payload) =>
  api.post(`${URL}/savesupervisedspecialists`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const getSpecialistByUserId = () =>
  api.get(`${URL}/getSpecialistByUserId`);

export const hasDataOnHealthDepartment = async (id, registrationNumber) => {
  return await api.get(
    `${URL}/hasDataOnHealthDepartment/${id}/${registrationNumber}`
  );
};

export const updateLicenseFromHd = async (registrationNumber) => {
  return await api.put(`${URL}/updateLicenseFromHd/${registrationNumber}`);
};

export const deleteTemporalSpecialist = async (id) => {
  return await api.delete(`${URL}/temporaldata/${id}`);
};

export const getMunicipalityOptions = async () => {
  return await api.get(`${URL}/municipalityOptions`);
};

export const getSpecialtyLevelTypes = async () => {
  return await api.get(`${URL}/specialtylevel-types`);
};
